import React, { createContext, useContext, useState, useEffect } from 'react';
import { mockUser, mockAdmin } from '../data/mock';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check for stored auth token
    const storedUser = localStorage.getItem('physiomobile_user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setIsLoading(false);
  }, []);

  const login = async (email, password, isAdmin = false) => {
    // Mock login - in real app, this would call backend API
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (isAdmin && email === 'admin@physiomobile.com' && password === 'admin123') {
          setUser(mockAdmin);
          localStorage.setItem('physiomobile_user', JSON.stringify(mockAdmin));
          resolve(mockAdmin);
        } else if (!isAdmin && email && password) {
          const customerUser = { ...mockUser, email };
          setUser(customerUser);
          localStorage.setItem('physiomobile_user', JSON.stringify(customerUser));
          resolve(customerUser);
        } else {
          reject(new Error('Invalid credentials'));
        }
      }, 500);
    });
  };

  const register = async (name, email, password) => {
    // Mock registration
    return new Promise((resolve) => {
      setTimeout(() => {
        const newUser = {
          ...mockUser,
          id: `user-${Date.now()}`,
          name,
          email,
        };
        setUser(newUser);
        localStorage.setItem('physiomobile_user', JSON.stringify(newUser));
        resolve(newUser);
      }, 500);
    });
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('physiomobile_user');
  };

  const guestCheckout = () => {
    return {
      id: `guest-${Date.now()}`,
      name: 'Guest',
      email: null,
      role: 'guest',
    };
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isLoading,
        isAuthenticated: !!user,
        isAdmin: user?.role === 'admin',
        login,
        register,
        logout,
        guestCheckout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};